module.exports = __webpack_public_path__ + "assets/pulse-secure.22b77cb4.svg";